import { config } from '@iheartjane/config';
import type { AppMode, User } from '@iheartjane/types';
import snakeCase from 'lodash-es/snakeCase';

import { loginRequest } from '../lib/request';

export interface RegisterArgs {
  app_mode_at_registration: AppMode;
  email: string;
  nickname?: string;
  password: string;
  phone: string;
  promotionsOptIn?: boolean;
  store_id_at_registration?: string | number;
}

interface ValidationError {
  error: string | null;
  id: string;
  status: number;
  validations: {
    email?: string[];
    password?: string[];
    phone?: string[];
  };
}

export interface RegisterSuccessResponse {
  body: {
    user: User;
  };
  headers: { Authorization: string };
}

export interface RegisterValidationErrorResponse {
  body: {
    errors: ValidationError;
  };
  headers: { Authorization?: string | null };
}

export type RegisterResponse =
  | RegisterSuccessResponse
  | RegisterValidationErrorResponse;

export const RegistrationSource = {
  register: async ({
    app_mode_at_registration,
    ...user
  }: RegisterArgs): Promise<RegisterResponse> => {
    const result = await loginRequest(`${config.apiPath}/users`, {
      method: 'POST',
      body: JSON.stringify({
        user: {
          ...(({ promotionsOptIn: _, ...rest }) => rest)(user),
          app_mode_at_registration: snakeCase(app_mode_at_registration),
        },
        promotions_opt_out:
          user.promotionsOptIn !== undefined
            ? !user.promotionsOptIn
            : undefined,
      }),
    });

    if ('error' in result.body) {
      throw result.body.error;
    }

    return result;
  },
};
